// src/components/chatting/GroupChat.js – light‑mode group chat
import React, { useState, useEffect, useRef,useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import {
  ArrowLeft,
  Smile,
  Paperclip,
  Send,
  Check,
  CheckCheck,
} from "lucide-react";
import "./WhatsAppChat.css";
import { useNavigate } from 'react-router-dom';
import badgev from '../../assets/images/Twitter_Verified_Badge.png';
import { AuthContext } from "../../context/AuthContext";

// demo data – replace or fetch from API / context
// const initialMessages = [
//   { id: 1, user: "Amit", fromMe: false, text: "Morning team!", time: "09:00", status: "read" },
//   { id: 2, user: "You", fromMe: false, text: "Good morning ✌️", time: "09:01", status: "read" },
//   { id: 3, user: "Sara", fromMe: false, text: "Stand-up at 10?", time: "09:02", status: "delivered" },
// ];

function Bubble({ msg }) {
  const align = msg.fromMe ? "bubble me" : "bubble";

  const Tick = () => {
    if (!msg.fromMe) return null;
    if (msg.status === "read") return <CheckCheck size={14} className="tick read" />;
    if (msg.status === "delivered") return <CheckCheck size={14} className="tick" />;
    return <Check size={14} className="tick" />;
  };

  return (
    <div className={align} title={msg.user}>
      {!msg.fromMe && <small className="sender-name">{msg.user}</small>}
      <span>{msg.text}</span>
      <div className="meta">
        <small>{msg.time}</small>
        <Tick />
      </div>
    </div>
  );
}

export default function WhatsAppChat() {
  const { id } = useParams();
  const [messages, setMessages] = useState([]);
  const [TotalMember, setTotalMember] = useState(4);
  const [GroupName, setGroupName] = useState("Test Group");
  const [GroupDP, setGroupDP] = useState("https://admin.aghorimatka.com/uploads/groups/b7988120f165879771dfe0acd771e5ad.png");
  const [Verified, setVerified] = useState(false);
  const [input, setInput] = useState("");
  const [IsMessage, setIsMessage] = useState(false);
  const intervalRef = useRef(null);
  const location = useLocation();
  const endRef = useRef(null);
  const { GroupinfoDetail, GroupChat, GroupInitiateChat } = useContext(AuthContext);

  const navigate = useNavigate();

  const handleGoBack = () => {
      navigate(-1);
  };

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  useEffect(() => {
    GroupinfoDetail(id,(res) => {
      if (res.status === 0) {
        alert(res.msg);
        return;
      }
      let daa = res.data;
      setGroupDP(daa.avatar);
      setGroupName(daa.name);
      setVerified(daa.verified);
      setTotalMember(daa.TotalMember ?? 0);
      setIsMessage(daa.messages);
    });
  }, [GroupinfoDetail]);
  useEffect(() => {
    const fetchMessages = () => {
      GroupChat(id, (res) => {
        if (res.status === 0) {
          return;
        }
        let daa = res.data;
        setMessages(daa ?? []);
      });
    };

    // Start polling only when this component is mounted
    intervalRef.current = setInterval(fetchMessages, 1000);

    // Cleanup when component unmounts (e.g., user leaves chat page)
    return () => {
      clearInterval(intervalRef.current);
    };
  }, [id]);
  useEffect(() => {
    GroupChat(id,(res) => {
      if (res.status === 0) {
        // alert(res.msg);
        return;
      }
      let daa = res.data;
      setMessages(daa ?? []);
    });
  }, [GroupChat]);
  const handleSend = () => {
    if (!input.trim()) return;
    const now = new Date();
    const time = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    GroupInitiateChat(id,input,(res) => {
      if (res.status === 0) {
        return;
      }
    });
    setMessages((prev) => [
      ...prev,
      { id: Date.now(), user: "You", fromMe: true, text: input, time, status: "sent" },
    ]);
    setInput("");
  };

  return (
    <div className="gc-page">
      {/* header */}
      <header className="gc-header">
        <button className="back-btn" onClick={handleGoBack} aria-label="Back">
          <ArrowLeft size={22} />
        </button>
        <img src={GroupDP} alt="Group" className="avatar" />
        <div className="info">
          <div style={{display: 'flex'}}>
          <h3 className="name">{GroupName}</h3> 
          {Verified ? <img src={badgev} style={{width:'20px'}}/> : ""}
          </div>
          <span className="sub">{TotalMember} members</span>
        </div>
      </header>

      {/* conversation */}
      <div className="gc-body">
        {messages.map((m) => (
          <Bubble key={m.id} msg={m} />
        ))}
        <div ref={endRef} />
      </div>
      {IsMessage ?
      <div className="composer">
        <input
          type="text"
          placeholder="Message"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
        />
        <button className="send-btn" onClick={handleSend} aria-label="Send">
          <Send size={22} />
        </button>
      </div>
      :
      <div className="composer">
       Only Admin can send messages.
      </div>
       }
    </div>
  );
}